import { Box } from '@chakra-ui/react';
import { IMediaPackPDFData } from '~/types';

import { ButtonsSection } from './components/ButtonsSection';

interface Props {
  exportPdfData: IMediaPackPDFData;
  previewAndShareLink: string;
}

export const FooterSection: React.FC<Props> = ({
  exportPdfData,
  previewAndShareLink,
}) => (
  <Box>
    <ButtonsSection
      exportPdfData={exportPdfData}
      previewAndShareLink={previewAndShareLink}
    />
  </Box>
);
